import React from 'react';
import ProductCard from '@stitch-fix/mode-react/ProductCard';
import { formatMoneyForLocale, useI18n } from '@stitch-fix/i18n';
import { FeedbackThumbs } from '@stitch-fix/product-card';
import AddToBagButton from '../AddToBagButton';
import { ShopMatchingSetItem } from '../../../types/definitions/vendor/graphql-schema.d';

type MatchingItemProductCardProps = {
  item: ShopMatchingSetItem;
  index: number;
};

export const MatchingItemProductCard = ({
  item,
  index,
}: MatchingItemProductCardProps) => {
  const { locale } = useI18n();
  const { sku, image, shopProduct, inseam, size, price, inventory, url } =
    item.variant;

  return (
    <ProductCard
      key={sku || index}
      heroMedia={{
        alt: '',
        baseUrl: image?.baseUrl || '',
        mediaPath: image?.mediaPath || '',
        sizes: { sm: 320 },
      }}
      eventOverrides={{
        view: {
          content_id: 'matching_set',
        },
      }}
      actionFooter={
        <AddToBagButton
          isSkuCardFormat
          skuId={sku}
          externalProductId={shopProduct.externalProductId}
          skuAvailability={inventory?.availability}
        />
      }
      heroSecondaryAction={
        <FeedbackThumbs
          itemIndex={index}
          page="product"
          source="PRODUCT_CAROUSEL"
          skuId={sku}
          sourceId="matching-set"
        />
      }
      name={shopProduct.name}
      brand={shopProduct.brand?.name}
      href={url}
      sku={sku}
      inseam={inseam?.name}
      size={size?.name}
      price={formatMoneyForLocale(locale, price, { subunits: true })}
    />
  );
};
